export const MDY = "MM/DD/YYYY"